module.exports = __webpack_public_path__ + "static/media/11.final.ea82b5c2.mp4";